import { makeStyles } from '@material-ui/core/styles'
import {
  colorWhite,
  colorWhiteAlpha10,
  colorWhiteAlpha80,
  colorWhiteAlpha90,
  layoutContentMaxWidthPx,
  transition,
} from '../../shared/style-settings'
import { createStyles, Theme } from '@material-ui/core'

export const useNewFooterStyles = makeStyles((theme: Theme) =>
  createStyles({
    topSpacer: {
      height: '2vw',
    },
    //Footer
    footerSection: {
      background: theme.palette.primary.main,
      padding: theme.spacing(5, 3, 0, 3),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(4, 2, 0, 2),
      },
    },
    footerHolder: {
      margin: '0 auto',
      maxWidth: layoutContentMaxWidthPx,
    },
    footerMenu: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5, 1),
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(1),
        alignItems: 'center',
        paddingLeft: 0,
      },
    },
    footerLogo: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(3),
      },
    },
    footerLink: {
      fontSize: '0.9375rem',
      color: colorWhiteAlpha90,
      display: 'inline-block',
      textDecoration: 'none',
      padding: theme.spacing(0.75, 1),
      borderRadius: theme.shape.borderRadius,
      fontWeight: 600,
      transition: transition,
      position: 'relative',
      textAlign: 'center',
      '&:hover': {
        color: colorWhite,
        backgroundColor: colorWhiteAlpha10,
        transform: 'translateY(-1px)',
      },
      '&:active': {
        transform: 'translateY(0)',
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.875rem',
        padding: theme.spacing(0.5, 0.75),
        width: '100%',
        textAlign: 'center',
        display: 'block',
        '&:hover': {
          transform: 'none',
        },
      },
    },
    subFooter: {
      background: theme.palette.primary.dark,
      padding: theme.spacing(2.5, 3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(-3),
      marginRight: theme.spacing(-3),
      marginBottom: theme.spacing(-3),
      color: colorWhiteAlpha80,
      textAlign: 'center',
      fontSize: '0.8125rem',
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 2),
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
        marginBottom: theme.spacing(-2),
        fontSize: '0.75rem',
      },
    },
  })
)
